// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3qk7I","footer":"ModalUpdate_footer__2xHL1"};